
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.4829 7.63406L12.6864 6.90408L10.5422 2.35214C10.4837 2.22751 10.3873 2.12662 10.2683 2.06529C9.96981 1.91099 9.6071 2.03957 9.45786 2.35214L7.3137 6.90408L2.51721 7.63406C2.38497 7.65384 2.26407 7.71912 2.1715 7.81803C2.05959 7.93848 1.99793 8.10053 2.00005 8.26856C2.00218 8.4366 2.06792 8.59688 2.18284 8.71418L5.65316 12.2572L4.83328 17.2602C4.81405 17.3766 4.82635 17.4963 4.86878 17.6057C4.91121 17.7151 4.98207 17.8099 5.07333 17.8793C5.16459 17.9488 5.27259 17.99 5.38509 17.9984C5.4976 18.0068 5.6101 17.982 5.70984 17.9269L10 15.5648L14.2902 17.9269C14.4074 17.9922 14.5434 18.0139 14.6737 17.9902C15.0024 17.9308 15.2235 17.6044 15.1668 17.2602L14.3469 12.2572L17.8172 8.71418C17.9117 8.61724 17.974 8.49064 17.9929 8.35216C18.0439 8.00597 17.8135 7.68549 17.4829 7.63406V7.63406Z"}})])
          )
        }
      }
    